module.exports = __webpack_public_path__ + "img/member-verify-bg-2.64a9a38e.png";